'use strict';

// import Notification from '../components/notification';

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd (response) {
    $('.js-mainHeader-minicart').trigger('count:update', response);
    var messageType = response.error ? 'alert-danger' : 'alert-success';

    if ($('.add-to-cart-messages').length === 0) {
        $('body').append(
            '<div class="add-to-cart-messages"></div>'
        );
    }

    $('.add-to-cart-messages').append(
        '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">'
        + response.message
        + '</div>'
    );

    setTimeout(function () {
        $('.add-to-basket-alert').remove();
    }, 5000);
}

/**
 * @param {Object} $elementAppendTo - The element to append error html to
 * @param {string} msg - The error message
 * display error message if remove item from wishlist failed
 */
function displayErrorMessage ($elementAppendTo, msg) {
    if ($('.remove-from-wishlist-messages').length === 0) {
        $elementAppendTo.append(
            '<div class="remove-from-wishlist-messages "></div>'
        );
    }
    $('.remove-from-wishlist-messages')
        .append('<div class="remove-from-wishlist-alert text-center alert-danger">' + msg + '</div>');

    setTimeout(function () {
        $('.remove-from-wishlist-messages').remove();
    }, 3000);
}

/**
 * renders the list up to a given page number
 * @param {number} pageNumber - current page number
 * @param {boolean} spinner - if the spinner has already started
 */
function renderNewPageOfItems (pageNumber, spinner = true) {
    var publicView = $('.wishlistItemCardsData').data('public-view');
    var listUUID = $('.wishlistItemCardsData').data('uuid');
    var url = $('.wishlistItemCardsData').data('href');
    if (spinner === true) {
        $.spinner().start();
    }
    var scrollPosition = document.documentElement.scrollTop;
    var newPageNumber = pageNumber;
    var isWoman = $('.js-wishlist_category_woman').hasClass('selected') === true;
    $.ajax({
        url: url,
        method: 'get',
        data: {
            pageNumber: ++newPageNumber,
            publicView: publicView,
            id: listUUID,
            isWoman: isWoman
        }
    }).done(function (data) {
        $('.list-container').empty();
        $('body .list-container').append(data);

        $('body .wishlist-items-count').text(parseInt($('body').find('.wishlist-product-card.product-info').length));
        // $('body .wishlist-items-count').text(parseInt($('body').find('.wishlist-item.real').length));

        document.documentElement.scrollTop = scrollPosition;
        checkAddAllButton();
        $.spinner().stop();
    }).fail(function () {
        $('.more-wl-items').remove();
        $.spinner().stop();
    });
}

function checkAddAllButton () {
    let buttons = $('.js-add-to-cart');
    let shouldDisable = false;

    if (buttons.length === 0) {
        shouldDisable = true;
    }

    for (let i = 0; i < buttons.length; i++) {
        if (buttons.eq(i).is(':disabled')) {
            shouldDisable = true;
            break;
        }
    }
    if (buttons.length === $('.add-to-cart:disabled').length) {
        $('.add-all-to-cart').addClass('d-none');
    }
    // Temporary kepp always enabled
    // $('.add-all-to-cart').prop('disabled', shouldDisable);
}

function changeWishlistItem (fromUUID, toPid, sender) {
    var form = {
        uuid: fromUUID,
        pid: toPid
    };

    $.spinner().start();

    $.ajax({
        url: $('.wishlist-container').data('update-url'),
        type: 'post',
        context: this,
        data: form,
        dataType: 'json',
        success: function () {
            var pageNumber = $('.wishlistItemCardsData').data('page-number') - 1;
            renderNewPageOfItems(pageNumber, false);
            $('.js-quickUpdateModal-closeIcon').trigger('click');
        },
        error: function () {
            $.spinner().stop();
            var msg = $('.btn-update-wishlist-product').data('error-msg');

            if ($('.update-wishlist-messages').length === 0) {
                $('body').append(
                    '<div class="update-wishlist-messages "></div>'
                );
            }

            $('.update-wishlist-messages')
                .append('<div class="update-wishlist-alert text-center alert-danger">' + msg + '</div>');

            setTimeout(function () {
                $('.update-wishlist-messages').remove();
            }, 5000);
        }
    });
}

// function renderNewPageOfItems (pageNumber, spinner) {
//     var publicView = $('.wishlistItemCardsData').data('public-view');
//     var listUUID = $('.wishlistItemCardsData').data('uuid');
//     var url = $('.wishlistItemCardsData').data('href');
//     if (spinner) {
//         $.spinner().start();
//     }
//     var scrollPosition = document.documentElement.scrollTop;
//     var newPageNumber = pageNumber;
//     $.ajax({
//         url: url,
//         method: 'get',
//         data: {
//             pageNumber: ++newPageNumber,
//             publicView: publicView,
//             id: listUUID
//         }
//     }).done(function (data) {
//         $('.wishlistItemCards').empty();
//         $('body .wishlistItemCards').parent().append(data);
//         document.documentElement.scrollTop = scrollPosition;
//     }).fail(function () {
//         $('.more-wl-items').remove();
//     });
//     $.spinner().stop();
// }

module.exports = {
    init: function () {
        checkAddAllButton();

        $('body').on('click', '.js-wishlist_category_woman', function (e) {
            e.preventDefault();
            $('.js-wishlist_category_woman').addClass('selected');
            $('.js-wishlist_category_men').removeClass('selected');
            $('.js-wishlist_men').addClass('hidden');
            $('.js-wishlist_woman').removeClass('hidden');
            $('.js-wishlist_woman').find('.js-add-to-cart').data('wishlist-category', 'active').attr('data-wishlist-category', 'active');
            $('.js-wishlist_men').find('.js-add-to-cart').data('wishlist-category', '').attr('data-wishlist-category', '');

            $('.js-wishlist-add-all-button').toggleClass('hide', $('.js-wishlist_woman').length === 0);
            $('.js-empty-wishlist').toggleClass('hide', $('.js-wishlist_woman').length > 0);
            $('.carveout-iuman-message').addClass('hidden');
        });

        $('body').on('click', '.js-wishlist_category_men', function (e) {
            e.preventDefault();
            $('.js-wishlist_category_woman').removeClass('selected');
            $('.js-wishlist_category_men').addClass('selected');
            $('.js-wishlist_men').removeClass('hidden');
            $('.js-wishlist_woman').addClass('hidden');
            $('.js-wishlist_woman').find('.js-add-to-cart').data('wishlist-category', '').data('attr-wishlist-category', '');
            $('.js-wishlist_men').find('.js-add-to-cart').data('wishlist-category', 'active').data('attr-wishlist-category', 'active');

            $('.js-wishlist-add-all-button').toggleClass('hide', $('.js-wishlist_men').length === 0);
            $('.js-empty-wishlist').toggleClass('hide', $('.js-wishlist_men').length > 0);
            $('.carveout-iuman-message').removeClass('hidden');
        });

        document.querySelectorAll('.wishlist-product-card').forEach(card => {
            if (card.querySelector('.product-card-label--warning')) {
                const actionBar = card.querySelector('.action-bar.grid-x');
                if (actionBar) {
                    actionBar.classList.add('has-warning');
                }
            }
        });
    },

    addAll: function () {
        $('body').on('click', '.add-all-to-cart', function (e) {
            let $allAddToCartBtns = $('.js-add-to-cart');
            var allAddToCartItems = [];
            $('body').trigger('product:beforeAddToCart', this);
            if ($('.js-add-to-cart:not(:disabled)').length > 0) {
                $.spinner().start();
            }
            for (let i = 0; i < $allAddToCartBtns.length; i++) {
                let $btn = $allAddToCartBtns.eq(i);
                // If the button is disabled, the product is not in stock, skip it.
                if ($btn.data('wishlist-category') !== 'active' || $btn.prop('disabled')) {
                    if (i === $allAddToCartBtns.length - 1) {
                        $('body').trigger('product:afterAddAllToCartWishlist', { allAddToCartItems });
                        $.spinner().stop();
                        document.location.reload();
                    }
                    continue;
                }
                let pid = $btn.data('pid');
                let addToCartUrl = $btn.data('url');
                let pidsQty = parseInt($btn.closest('.product-info').find('.quantity').val(), 10);

                var form = {
                    pid: pid,
                    quantity: pidsQty || 1
                };
                $(this).trigger('updateAddToCartFormData', form);
                if (addToCartUrl) {
                    $.ajax({
                        url: addToCartUrl,
                        method: 'POST',
                        data: form,
                        success: function (data) {
                            checkAddAllButton();
                            if (i === $allAddToCartBtns.length - 1) {
                                $.spinner().stop();
                                document.location.reload();
                            }
                        },
                        error: function () {
                            if (i === $allAddToCartBtns.length - 1) {
                                $.spinner().stop();
                                document.location.reload();
                            }
                        }
                    });
                    let container = $btn.closest('.wishlist-product-card').find('.productListingItem.analytics');
                    let additionalDataContainer = container.find('.clickAdditionalAttributes');
                    allAddToCartItems.push({...container.data(), ...additionalDataContainer.data()});
                    if (i === $allAddToCartBtns.length - 1) {
                        $('body').trigger('product:afterAddAllToCartWishlist', { allAddToCartItems });
                    }
                }
            }
        });
    },

    removeFromWishlist: function () {
        $('body').on('click', '.remove-from-wishlist', function (e) {
            e.preventDefault();
            var url = $(this).data('url');
            var pid = $(this).data('pid');
            var elMyAccount = $('.account-wishlist-item').length;

            // If user is in my account page, call removeWishlistAccount() end point, re-render wishlist cards
            if (elMyAccount > 0) {
                $.spinner().start();
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'html',
                    data: {},
                    success: function (html) {
                        $('body').trigger('wishlist:remove', { sku: pid });
                        window.location.reload();
                        $('.wishlist-account-card>.card').remove();
                        $('.wishlist-account-card').append(html);
                        $('.wishlist-account-card').spinner().stop();

                        // const notification = new Notification();
                        // notification.setContent(response.msg);
                        // notification.show();
                        // notification.timeout(5000);
                    },
                    error: function () {
                        var $elToAppend = $('.wishlist-account-card');
                        $elToAppend.spinner().stop();
                        var msg = $elToAppend.data('error-msg');
                        displayErrorMessage($elToAppend, msg);
                    }
                });
            // else user is in wishlist landing page, call removeProduct() end point, then remove this card
            } else {
                $.spinner().start();
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    data: {},
                    success: function (response) {
                        $('body').trigger('wishlist:remove', { sku: pid });
                        var pageNumber = $('.wishlistItemCardsData').data('page-number') - 1;
                        renderNewPageOfItems(pageNumber, false);
                        $('body').trigger('wishlist:update', response.wishlistTotal);
                        // const notification = new Notification();
                        // notification.setContent(response.msg);
                        // notification.show();
                        // notification.setType('success');
                        // notification.timeout(5000);
                    },
                    error: function () {
                        $.spinner().stop();
                        var $elToAppendWL = $('.wishlistItemCards');
                        var msg = $elToAppendWL.data('error-msg');
                        displayErrorMessage($elToAppendWL, msg);
                    }
                });
            }
        });
    },

    updateWishlistUpdateButton: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            response.$productContainer.find('.btn-update-wishlist-product').attr('disabled', !response.product.readyToOrder || !response.product.available);
        });
    },

    addToCartFromWishlist: function () {
        $('body').on('click', '.js-add-to-cart', function () {
            var pid;
            var addToCartUrl;
            var pidsQty;

            $('body').trigger('product:beforeAddToCart', this);

            pid = $(this).data('pid');
            addToCartUrl = $(this).data('url');
            pidsQty = parseInt($(this).closest('.product-info').find('.quantity').val(), 10);
            var promoId = $(this).data('promotion-id') || false;
            var $productContainer = $(this).closest('.wishlist-product-card');
            const GTMIndex = $(this).closest('.wishlist-item').find('.analytics.productListingItem').data('index');

            var form = {
                pid: pid,
                quantity: pidsQty || 1,
                promoId: promoId,
                GTMItemListName: 'wishlist',
                GTMItemListId: 'wishlist',
                GTMIndex: GTMIndex
            };

            if ($(this).data('option')) {
                form.options = JSON.stringify($(this).data('option'));
            }
            $.spinner().start();

            $(this).trigger('updateAddToCartFormData', form);

            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: function (data) {
                        handlePostCartAdd(data);
                        $('body').trigger('product:afterAddToCart', { ...data, form, $productContainer });
                        checkAddAllButton();

                        let itemsOriginallyInWishlist = $('#wishlistItems').val();
                        let newItemsInWishlist = [];
                        let itemsInWishlist = itemsOriginallyInWishlist.split(',');
                        for (var i = 0; i < itemsInWishlist.length; i++) {
                            if (itemsInWishlist[i] !== pid) {
                                newItemsInWishlist.push(itemsInWishlist[i]);
                            }
                        }
                        $('#wishlistItems').val(itemsInWishlist.join(','));
                        $('body').trigger('wishlist:update', data.wishlistTotal);

                        var pageNumber = $('.wishlistItemCardsData').data('page-number') - 1;
                        renderNewPageOfItems(pageNumber, false);
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    },
    moreWLItems: function () {
        $('body').on('click', '.more-wl-items', function () {
            var pageNumber = $('.wishlistItemCardsData').data('page-number');
            renderNewPageOfItems(pageNumber, true);
        });
    },
    sizeAttribute () {
        $('body').on('change', '[data-attr="size"] input', e => {
            e.preventDefault();

            const selectedValue = $(e.currentTarget).attr('value');
            if (selectedValue === 'null') {
                return;
            }

            // Don't change if the selectionis the same already selected
            if ($(e.currentTarget).closest('input').hasClass('current')) {
                return;
            }

            let $productContainer = $(e.currentTarget).closest('.wishlist-product-card.product-info');

            $.spinner().start();
            $.ajax({
                url: selectedValue.replace('undefined', '1'),
                method: 'GET',
                success: function (data) {
                    if (data != null) {
                        if (!data.product.readyToOrder){
                            $.spinner().stop();
                        } else {
                            let toChangePID = data.product.id;
                            changeWishlistItem($productContainer.data('uuid'), toChangePID, $productContainer);
                        }
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    proceedButtonMobile () {
        $('body').on('wishlist:quickUpdateProduct', function (e, data) {
            e.preventDefault();
            let $productContainer = data.container;
            let toChangePID = data.newProductId;
            changeWishlistItem($productContainer.data('uuid'), toChangePID, $productContainer);
        });
    }

};
